import * as bcrypt from 'bcryptjs';
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

// Hash the QL_AUTH_TOKEN using bcrypt
const hashedToken = bcrypt.hashSync(process.env.NEXT_PUBLIC_QL_AUTH_TOKEN || '', 10);

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: process.env.NEXT_PUBLIC_GRAPHQL_BASE_URL,
    headers: {
      authorization: hashedToken,
    },
  }),
});
